import { DateRangeHandler } from '@spotahome/ui-library';
import {
  subtractDaysToDate,
  addDaysToDate
} from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';

const FLEXIBLE_DAYS = 15;

export const getRentableUnitPrice = (
  type,
  minimumPrice,
  currencyCode,
  pricesByMonth,
  fixedPrice,
  { moveIn, moveOut } = {},
  { flexibleMoveIn, flexibleMoveOut } = {}
) => {
  const price = {
    type,
    amount: minimumPrice,
    currencyCode,
    fixedPrice,
    seasonalPrice: null, // Review if this is still needed
    isSeasonalPriceFeatureOn: true // Refactor condition in RentableUnitPrice component
  };

  // Not seasonal price
  if (type !== 'byMonth') {
    return price;
  }

  // No dates
  if (!moveIn) {
    const values = Object.values(pricesByMonth).filter(p => parseInt(p, 10));

    return {
      ...price,
      seasonalPrice: {
        min: Math.min(...values),
        max: Math.max(...values)
      },
      fixedPrice: minimumPrice
    };
  }

  let moveInToUse = moveIn;
  let moveOutToUse = moveOut;

  if (flexibleMoveIn) {
    moveInToUse = subtractDaysToDate(moveIn, FLEXIBLE_DAYS);
  }
  if (flexibleMoveOut) {
    moveOutToUse = addDaysToDate(moveOut, FLEXIBLE_DAYS);
  }

  const monthsStaying = DateRangeHandler.getMonthsStaying(
    moveInToUse,
    moveOutToUse
  );

  const seasonalPrice = Object.keys(pricesByMonth)
    .filter(month => pricesByMonth[month] !== 'PriceByMonth')
    .filter(month => monthsStaying.includes(month))
    .map(month => pricesByMonth[month])
    .sort((minPrice, maxPrice) => minPrice - maxPrice);

  const min = seasonalPrice[0];
  const max = seasonalPrice[seasonalPrice.length - 1];

  if (min === max) {
    price.fixedPrice = min;
    price.type = 'fixed';
    price.amount = price.fixedPrice;
  } else {
    price.seasonalPrice = { min, max };
  }
  return price;
};

export default { getRentableUnitPrice };
